<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

import { useCountdown } from '@/composables/useCountdown';
import { useCheckoutAnalytics } from '@/composables/useCheckoutAnalytics';

const { trackCheckoutCompletePageCompleted } = useCheckoutAnalytics();
const { t } = useI18n();

const handleFinalizeCheckout = () => {
  trackCheckoutCompletePageCompleted();
  window.location.reload();
};

const { initializeTimer, stopTimer, secondsRemaining } = useCountdown(30, handleFinalizeCheckout);

onMounted(() => {
  initializeTimer();
});

onUnmounted(() => {
  stopTimer();
});
</script>

<template>
  <div class="juno-i18n-exclude fill-height d-flex flex-column gap-6 pt-4 bg-secondary">
    <div class="d-flex flex-column gap-4 mt-6 px-4 flex-grow-1">
      <h1 class="typography-heading-md-bold d-flex align-center gap-2">
        <v-icon color="success">mdi-check-circle-outline</v-icon>
        {{ t('checkoutCompletePage.heading') }}
      </h1>

      <p class="typography-body-md mt-auto">
        {{ t('checkoutCompletePage.helpText') }}
      </p>

      <div class="pb-4">
        <v-btn block color="primary" @click="handleFinalizeCheckout">
          {{ t('common.actions.finalizeWithCountdown', { seconds: secondsRemaining }) }}
        </v-btn>
      </div>
    </div>
  </div>
</template>
